<template>
	<div class="full flex" style="overflow: auto;flex-direction: column;">
		<el-row v-if="false">
			<el-col class="block" :span="24" style="height: 70px;">
				<Header />
			</el-col>
		</el-row>
		<el-row>
			<el-col class="block" :span="16">
				<div class="">
					<el-tabs class="" type="border-card" v-model="currentblock1">
						<el-tab-pane label="待办事项" name="matter">
							<span slot="label">
								<div class="el-icon-loading" v-if="currentblock1=='matter' && tabloading && type=='matter'"></div>
								<div class="el-icon-refresh-right" @click="reflash('matter')" v-else></div>
								<span style="margin-left: 6px;">待办事项</span>
							</span>
							<div class="box">
								<Matter ref="matter" />
							</div>
						</el-tab-pane>
						<el-tab-pane label="未结办事项" name="unfinishedmatter">
							<span slot="label">
								<div class="el-icon-loading" v-if="currentblock1=='unfinishedmatter' && tabloading && type=='unfinishedmatter'"></div>
								<div class="el-icon-refresh-right" @click="reflash('unfinishedmatter')" v-else></div>
								<span style="margin-left: 6px;">未结办事项</span>
							</span>
							<div class="box">
								<Unfinishedmatter ref="unfinishedmatter" />
							</div>
						</el-tab-pane>
<!-- 						<el-tab-pane label="历史事项">
							<div class="box">321</div>
						</el-tab-pane> -->
					</el-tabs>
				</div>
			</el-col>
			<el-col class="block" :span="8">
				<div class="">
					<el-tabs class="" type="border-card" v-model="currentblock3">
						<el-tab-pane label="我的消息" name="mymessage">
							<span slot="label">
								<div class="el-icon-loading" v-if="currentblock1=='mymessage' && tabloading && type=='mymessage'"></div>
								<div class="el-icon-refresh-right" @click="reflash('mymessage')" v-else></div>
								<span style="margin-left: 6px;">我的消息</span>
							</span>
							<div class="box">
								<Message ref="mymessage" :type="1" />
							</div>
						</el-tab-pane>
						<el-tab-pane label="系统消息" name="systemmessage">
							<span slot="label">
								<div class="el-icon-loading" v-if="currentblock1=='systemmessage' && tabloading && type=='systemmessage'"></div>
								<div class="el-icon-refresh-right" @click="reflash('systemmessage')" v-else></div>
								<span style="margin-left: 6px;">系统消息</span>
							</span>
							<div class="box">
								<Message ref="systemmessage" :type="0" />
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</el-col>
		</el-row>
		<el-row class="flowtemplate_container" style="flex: 1;box-sizing: border-box;">
			<el-col class="block" :span="24">
				<div class="full" style="position: relative;">
					<el-tabs class="full" type="border-card" v-model="currentblock2">
						<el-tab-pane label="流程模板" name="flowtemplate">
							<span slot="label">
								<div class="el-icon-loading" v-if="currentblock2=='flowtemplate' && tabloading && type=='flowtemplate'"></div>
								<div class="el-icon-refresh-right" @click="reflash('flowtemplate')" v-else></div>
								<span style="margin-left: 6px;">流程模板</span>
							</span>
							<div class="box" >
								<Flowtemplate ref="flowtemplate" />
							</div>
						</el-tab-pane>
						<el-tab-pane label="我的报表" name="report">
							<span slot="label">
								<div class="el-icon-loading" v-if="currentblock2=='report' && tabloading && type=='report'"></div>
								<div class="el-icon-refresh-right" @click="reflash('report')" v-else></div>
								<span style="margin-left: 6px;">我的报表</span>
							</span>
							<div class="box">
								<Report ref="report" />
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<style>
	
	.flowtemplate_container .el-tabs__content {
		height: calc(100% - 39px);
	}
</style>
<style scoped>
	.block {
		height: 100%;
		box-sizing: border-box;
		padding: 10px;
	}

	.box {
		width: 100%;
		height: 300px;
	}
</style>
<script>
	import Matter from './matter/index.vue'
	import Unfinishedmatter from './unfinishedmatter/index.vue'
	import Flowtemplate from './flowtemplate/index.vue'
	import Report from './report/index.vue'
	import Message from './message/index.vue'
	import Header from './header/index.vue'
	export default {
		name: 'cooperateIndex',
		props: {

		},
		data() {
			return {
				currentblock1: 'matter',
				currentblock2:'flowtemplate',
				currentblock3:'mymessage',
				tabloading: false,
				type:''
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			reflash(type) {
				this.type = type
				this.tabloading = true
				this.$refs[type].list().then(() => {
					this.tabloading = false
					this.type = ''
				})
			}
		},
		components: {
			Matter,
			Unfinishedmatter,
			Flowtemplate,
			Report,
			Message,
			Header
		}
	}
</script>
